var _path, _path2, _g, _path3, _g2, _path4, _g3, _path5, _g4, _path6, _g5, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 181,
    height: 61,
    viewBox: "0 0 181 61",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.9082 15.9894C96.4486 7.07087 103.655 0 112.451 0C121.248 0 128.452 7.07087 128.992 15.9894H120.671C120.158 11.7861 116.67 8.53224 112.449 8.53224C108.229 8.53224 104.741 11.7861 104.227 15.9894H95.9062H95.9082Z",
    fill: "#FA255D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2372_3226",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 14,
    width: 13,
    height: 46
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.251953 23.1771H12.4623V14.5078H0.251953V23.1771ZM0.497417 59.7074H12.2131V26.212H0.49932V59.7093L0.497417 59.7074Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2372_3226)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.8057,
    height: 48.3164,
    transform: "matrix(1 0 0 -1 -1.31641 61.5059)",
    fill: "url(#pattern0_2372_3226)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2372_3226",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 16,
    width: 42,
    height: 44
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4297 59.7096H31.269V35.9339L49.7054 59.7096H60.1881V16.3672H48.3487V39.2771L30.5897 16.3672H19.4297V59.7096Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2372_3226)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.8152,
    height: 46.2156,
    transform: "matrix(1 0 0 -1 17.4785 61.2852)",
    fill: "url(#pattern1_2372_3226)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_2372_3226",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 66,
    y: 26,
    width: 34,
    height: 35
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M78.2509 60.4542C82.9984 60.4542 86.0809 57.9158 88.2406 55.1301V59.7121H99.9563V26.2148H88.2406V44.3563C88.2406 48.0097 86.1456 49.9906 83.3694 49.9906C80.5932 49.9906 78.6219 48.0078 78.6219 44.3563V26.2148H66.9062V48.1334C66.9062 55.7504 71.161 60.4561 78.2509 60.4561V60.4542Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_2372_3226)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36.4123,
    height: 37.1126,
    transform: "matrix(1 0 0 -1 65.3418 61.9453)",
    fill: "url(#pattern2_2372_3226)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_2372_3226",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 106,
    y: 14,
    width: 37,
    height: 47
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M128.138 60.4514C136.031 60.4514 142.875 53.8277 142.875 42.9284V42.8047C142.875 32.0937 136.031 25.4681 128.077 25.4681C123.082 25.4681 120.247 27.8847 117.964 30.6704V14.5098H106.248V59.7093H117.964V55.624C120.121 58.1623 123.08 60.4533 128.138 60.4533V60.4514ZM124.502 50.6062C120.74 50.6062 117.718 47.4494 117.718 42.9911V42.8675C117.718 38.472 120.738 35.3133 124.502 35.3133C128.266 35.3133 131.346 38.4701 131.346 42.8675V42.9911C131.346 47.5103 128.325 50.6062 124.502 50.6062Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_2372_3226)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42.0142,
    height: 49.0166,
    transform: "matrix(1 0 0 -1 104.215 62.3965)",
    fill: "url(#pattern3_2372_3226)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_2372_3226",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 146,
    y: 25,
    width: 35,
    height: 36
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M164.453 60.513C171.113 60.513 175.737 57.7881 178.943 53.7028L172.47 48.3159C170.065 50.6697 167.844 51.7219 165.07 51.7219C161.433 51.7219 158.781 49.8648 157.856 46.2114H180.178C180.239 45.4065 180.239 44.5407 180.239 43.7967C180.239 33.9515 174.936 25.4688 163.407 25.4688C153.54 25.4688 146.574 33.2094 146.574 42.9918V43.1155C146.574 53.5163 153.974 60.5149 164.455 60.5149L164.453 60.513ZM157.67 40.2023C158.288 36.5489 160.383 34.1342 163.466 34.1342C166.548 34.1342 168.831 36.488 169.262 40.2023H157.668H157.67Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_2372_3226)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39.2133,
    height: 37.8128,
    transform: "matrix(1 0 0 -1 144.697 62.4629)",
    fill: "url(#pattern4_2372_3226)"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4811 14.4473H0.240234V23.1907H12.4811V14.4473Z",
    fill: "#256DFA"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_2372_3226",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2372_3226",
    transform: "scale(0.04 0.0140845)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern1_2372_3226",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image1_2372_3226",
    transform: "scale(0.0151515 0.0144928)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern2_2372_3226",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image2_2372_3226",
    transform: "scale(0.0185185 0.0181818)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern3_2372_3226",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image3_2372_3226",
    transform: "scale(0.016129 0.0138889)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern4_2372_3226",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image4_2372_3226",
    transform: "scale(0.0172414 0.0178571)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_2372_3226",
    width: 25,
    height: 71,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAABHCAYAAADybezkAAAACXBIWXMAAAMTAAADEwE9ZoPHAAAAWUlEQVRYhe3ZsQ3AMAgEQIgyCfvP5FVwEblKGzvNfYUo/kRNdnfHxmRmXjuBlXsNVfVJ4RjjtTtyCQQCgUAgEAgEAoFAIBAIBAKBQCAQCOQH5MjjbGf/k4iYEFoLjZub7ywAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image1_2372_3226",
    width: 66,
    height: 69,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEIAAABFCAYAAAD+UTBQAAAACXBIWXMAAAMTAAADEwE9ZoPHAAAAp0lEQVR4nO3cwQlCQQxAwShWsv3XtK3sB32CJXxw5pJreOSc4eNxzjlazDxvsMMtvL5LrLX+MsDe+z1dRISIEBEiQkSICBEhIkSEiBARIkJEiAgRISJEhIgQESJCRIgIESEiRISIEBEiQkSICBEhIkSEiBARIkJEiAgRISJEhIgQESJCRIgIESEiRISIEBEiQkSICBEhIkSEiBARIkJEiAgRH0X4MTMXkWsLf0VVdZQAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image2_2372_3226",
    width: 54,
    height: 55,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADYAAAA3CAYAAABHGbl4AAAACXBIWXMAAAMTAAADEwE9ZoPHAAAAeElEQVRoge3asQ2AQAzFUD5ikuw/U1YJFWyAhCO7SnXKU9o7tpaZmW22JDl/sMcnXc+jVYXHdPc7r72YMFrCaAmjJYyWMFrCaAmjJYyWMFrCaAmjJYyWMFrCaAmjJYyWMFrCaAmjJYyWMFrCaAmjJYzWWtjOz85JbsJEC21X6itjAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    id: "image3_2372_3226",
    width: 62,
    height: 72,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD4AAABICAYAAACuukaYAAAACXBIWXMAAAMTAAADEwE9ZoPHAAAAiUlEQVR4nO3csQ3DMAwAwTDIJNp/Jq0iV65SGy7ur2Il8MFec845H8zMzFeLvv3uYa31+jJP2Xv/vcxevHBN4ZrCNYVrCtcUrilcU7imcE3hmsI1hWsK1xSuKVxTuKZwTeGawjWFawrXFK4pXFO4pnBN4ZrCNYVrCtcUrilcU7imcA0bbn6HMjMXbSkLkQrA0aoAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image4_2372_3226",
    width: 58,
    height: 56,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADoAAAA4CAYAAACsc+sjAAAACXBIWXMAAAMTAAADEwE9ZoPHAAAAfElEQVRoge3bsQ3AMAgAQYgyCfvPxCqkcpcySqL3X0Vl8aJ2zswEXGbmQY9czjVU1efLPKG7b1/Z5qKG0hhKYyiNoTSG0hhKYyiNoTSG0hhKYyiNoTSG0hhKYyiNoTSG0hhKYyiNoTSG0hhKYyiNoTSG0mzzS+IHa7wgIi4mAAtveDM2wAAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.44c96735c5ced81ded805c57d9a41d5a.svg";
export { ForwardRef as ReactComponent };